/* import __COLOCATED_TEMPLATE__ from './fade-text.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { typeOf } from '@ember/utils';
import { htmlSafe } from '@ember/template';
import { action } from '@ember/object';
let FadeTextComponent = (_class = class FadeTextComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "textHeight", _descriptor, this);
    _defineProperty(this, "MAX_HEIGHT", 200);
  }
  get text() {
    if (!this.args.text) {
      return '';
    }
    if (typeOf(this.args.text) !== 'string') {
      if (typeOf(this.args.text) === 'array') {
        let text = '<ul>';
        text += this.args.text.map(elem => `<li>${elem}</li>`).join('');
        text += '</ul>';
        return text;
      }
      return this.args.text.toString();
    }
    return this.args.text;
  }
  get displayText() {
    return new htmlSafe(this.text);
  }
  get textHeightRounded() {
    return Math.floor(this.textHeight);
  }
  get exceedsHeight() {
    return this.textHeightRounded >= this.MAX_HEIGHT;
  }
  get shouldFade() {
    if (this.expanded !== undefined) {
      return this.expanded ? false : this.exceedsHeight;
    }
    return this.exceedsHeight;
  }
  get expanded() {
    return this.args.expanded && this.exceedsHeight;
  }
  expand(event) {
    if (event) {
      event.stopPropagation();
    }
    this.args.onExpandAll(true);
  }
  collapse(event) {
    if (event) {
      event.stopPropagation();
    }
    this.args.onExpandAll(false);
  }
  updateTextDims({
    contentRect: {
      height
    }
  }) {
    this.textHeight = height;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "textHeight", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "expand", [action], Object.getOwnPropertyDescriptor(_class.prototype, "expand"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collapse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "collapse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateTextDims", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateTextDims"), _class.prototype), _class);
export { FadeTextComponent as default };